<script setup lang="ts">
import { KsExpand, KsExpandItem } from "@aschehoug/kloss";

const article = inject(keys.currentArticle);
</script>

<template>
  <article
    v-if="article?.contentType === 'article'"
    class="article article-body relative text-green-50"
    :class="article?.colorTheme"
  >
    <div class="article__paragraphs flex flex-col gap-4">
      <UiArticlesText
        v-for="(paragraph) in article?.body"
        :key="paragraph"
        :paragraph="paragraph"
      />
      <section v-if="article?.inlineCtas?.length" class="my-8 flex flex-wrap justify-center gap-8">
        <CtaForArticles :content="article.inlineCtas" />
      </section>
      <UiArticlesText
        v-for="paragraph in article?.postCtaBody"
        :key="paragraph"
        :paragraph="paragraph"
      />
      <div
        v-if="article?.extraBox && article.extraBox !== '<p></p>'"
        class="mx-0 my-4 bg-[--foreground] px-14 py-8 text-[--background]"
        v-html="article.extraBox"
      />
      <template v-if="article?.footnotes && article.footnotes !== '<p></p>'">
        <hr />
        <div class="mx-0 my-8 text-sm leading-5" v-html="article.footnotes" />
        <hr />
      </template>
      <div v-if="article?.accordion?.length" class="mt-6 flex flex-col gap-2">
        <div
          v-for="item in article.accordion"
          :key="item.title"
        >
          <h3
            v-if="item.groupTitle"
            class="!mt-10"
            v-text="item.groupTitle"
          />
          <KsExpand class="bg-white [--ks-secondary:theme(colors.green.60)]">
            <KsExpandItem
              :title="item.title"
              shape="squared"
              class="!bg-white"
            >
              <template #content>
                <div v-html="item.content" />
              </template>
            </KsExpandItem>
          </KsExpand>
        </div>
      </div>
    </div>
  </article>
</template>

<style scoped>
.article {
  h2,
  h3,
  h4,
  h5 {
    margin: 1.4rem 0 1rem 0;
  }

  &__paragraphs {
    :deep(p) {
      margin-bottom: 0.8rem;
    }

    h2,
    h3,
    h4 {
      margin-block: 1rem;
    }

    div p h4,
    div p h5 {
      margin: 2rem 0 1rem 0;
    }

    ul {
      li {
        padding: 0.4rem 0;
        margin-left: 1.4rem;

        @media screen and (min-width: theme("screens.sm")) {
          margin: 0;
        }
      }
    }
  }
}
</style>
